import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { useTranslation } from 'react-i18next';
import { MerchantUserEnum } from '../../../enums/merchantUser';

interface Props {
    value: MerchantUserEnum,
    onChange: (newValue: MerchantUserEnum) => void
}

const TabPanelMerchantRole = ({ value, onChange }: Props) => {
    const { t } = useTranslation("global");
    return (
        <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR , mb:1}}>
            <Box sx={{ borderBottom: 'none', borderColor: 'divider' }}>
                <Tabs value={value} onChange={(e: any, newValue: MerchantUserEnum) => {
                    onChange(newValue);
                }} variant="scrollable"
                    scrollButtons="auto">
                    <Tab label={t("merchantUser_page.Merchant")} value={MerchantUserEnum.MERCHANT} sx={{ textTransform: 'none' }} />
                    <Tab label={t("merchantUser_page.Staff")} value={MerchantUserEnum.STAFF} sx={{ textTransform: 'none' }} />
                </Tabs>
            </Box>
        </Box>
    );
}

export default TabPanelMerchantRole